import React from 'react'

import {AuthPage} from '@/modules/auth'



export function PublicRoutes() {
  return <AuthPage />
}
